<template>
  <div>
    <!-- Wenn es keine Segmente gibt werden striche als Platzahlter angezeigt -->
    <div v-if="flug.segmente.length == 0" class="d-flex align-items-center">
      <!-- Abflughafen - Seite -->
      <div class="d-flex flex-column" style="width: 140px">
        <div class="mb-2 grey500" style="text-align: center">---</div>
        <div
          class="d-flex justify-content-center grey400"
          style="gap: 3px; align-items: center; height: 21px"
        >
          -
        </div>
      </div>

      <div style="flex-grow: 1; display: flex; flex-direction: column; align-items: center">
        <div>
          <i v-if="flug.einkaeufer === 'Dmc'" class="fas fa-ticket-alt text-success"></i>
          <i v-else class="fas fa-ticket-alt text-danger"></i>
        </div>

        <div class="horizontal-line w-100"></div>
      </div>

      <!-- Zielflughafen - Seite  -->
      <div class="d-flex flex-column" style="width: 140px">
        <div class="mb-2 grey500" style="text-align: center">---</div>
        <div
          class="d-flex justify-content-center grey400"
          style="gap: 3px; align-items: center; height: 21px"
        >
          -
        </div>
      </div>
    </div>

    <!-- Wenn segmente vorhanden sind -->
    <div
      v-for="(segment, index) in flug.segmente"
      :key="index"
      class="d-flex align-items-center"
      :style="
        segment?.segmentStatus === 'UN' || segment?.segmentStatus === 'TK'
          ? 'border: 1px solid #FFA800; border-radius: 12px; padding: 4px'
          : ''
      "
    >
      <!-- Abflughäfen - Seite -->
      <div class="d-flex flex-column" style="width: 140px">
        <div class="mb-2 grey500" style="text-align: center">
          {{ segment?.abflughafen ?? '---' }}
        </div>
        <div class="d-flex justify-content-center grey400" style="gap: 3px; align-items: center">
          <PlaneTakeoff
            :size="17"
            :class="[segment?.restriktionenAbflugOutOfWindow ? 'icon-warning' : 'icon-success']"
          />
          {{ formatDate(segment?.abflugsdatum) }}
        </div>
      </div>

      <!-- Div aus Ticket icon - Dashed Line - betreiber und Flugnummer -->
      <div style="flex-grow: 1; display: flex; flex-direction: column; align-items: center">
        <div>
          <i
            v-if="segment?.buchungsstatus === 'TicketIssued' || flug.einkaeufer === 'Dmc'"
            class="fas fa-ticket-alt text-success"
          ></i>
          <i v-else class="fas fa-ticket-alt text-danger"></i>
        </div>

        <!-- Dashed line -->
        <div class="horizontal-line w-100"></div>

        <div
          v-if="segment != null"
          class="mt-4"
          :style="{
            color: segment.flugnummerNotMatching ? '#FFA800' : '#464e5f',
            fontWeight: segment.flugnummerNotMatching ? 600 : 400,
          }"
        >
          {{ segment.betreiber + '' + segment.flugnummer }}
        </div>
        <div v-if="flug.einkaeufer === 'Dmc'" class="grey400">Von DMC eingekauft</div>
      </div>

      <!-- Zielflughäfen - Seite  -->
      <div class="d-flex flex-column" style="width: 140px">
        <div class="mb-2 grey500" style="text-align: center">
          {{ segment?.zielflughafen ?? '---' }}
        </div>
        <div class="d-flex justify-content-center grey400" style="gap: 3px; align-items: center">
          <PlaneLanding
            v-if="segment != null && flug.restriktionenRueckRelevant"
            :size="17"
            :class="[segment?.restriktionenAnkunftOutOfWindow ? 'icon-warning' : 'icon-success']"
          />
          {{ formatDate(segment?.ankunftsdatum) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { format } from 'date-fns';
import { PlaneTakeoff, PlaneLanding } from 'lucide-vue';

export default {
  components: { PlaneTakeoff, PlaneLanding },

  props: { flug: { type: Object } },
  data() {
    return {};
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';

      return format(new Date(date.slice(0, -1)), 'dd.MM.yy HH:mm');
    },
  },
};
</script>
<style scoped>
.horizontal-line {
  border-top: 1px dashed #c5ced6;
  height: 0;
  flex-grow: 1;
  margin-left: 8px;
  margin-right: 8px;
}

.grey400 {
  font-weight: 400;
  color: var(--text-body);
}

.grey500 {
  font-weight: 500;
  color: var(--text-body);
  font-size: 20px;
}

.icon-success {
  stroke: var(--success);
  fill: var(--success);
}

.icon-warning {
  stroke: var(--warning);
  fill: var(--warning);
}
</style>
